<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Szülői jegyek</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <!-- Tanulói belépésnél nincs mit választani: a saját nevét írjuk ki, rögzítve. -->
      <ion-col size="12" sizeLg="5" *ngIf="sajatSor">
        <ion-input label="Tanuló" label-placement="stacked" fill="outline" readonly
                   [value]="sajatSor.full_name || sajatSor.name">
          <ion-icon slot="start" name="person" aria-hidden="true"></ion-icon>
        </ion-input>
      </ion-col>
      <ion-col size="12" sizeLg="5" *ngIf="!sajatSor">
        <ng-select
          appendTo="body"
          [notFoundText]="'Nincs találat'"
          [items]="gyerekek"
          placeholder="Gyermek kiválasztása*"
          bindValue="oktazon"
          [multiple]="false"
          [closeOnSelect]="true"
          [(ngModel)]="kivtanulo"
          (change)="onTanuloValtozas($event)"
          bindLabel="name">
        </ng-select>
      </ion-col>
      <!-- A szülőnek nincs fejléc-tanévválasztója, ezért itt kap egyet: enélkül a
           korábbi évek jegyei elérhetetlenek maradnának. -->
      <ion-col size="12" sizeLg="3" *ngIf="tanevLista.length > 1">
        <ion-select fill="outline" label="Tanév" labelPlacement="stacked" interface="popover"
                    [value]="aktivTanev" (ionChange)="tanevValt($event.detail.value)">
          <ion-select-option *ngFor="let t of tanevLista" [value]="t.ev">{{ t.cimke }}</ion-select-option>
        </ion-select>
      </ion-col>
      <!-- A stornózott jegyek alapból rejtve, a kapcsolóval láthatók (user, 2026-11-05). -->
      <ion-col size="12" sizeLg="3" class="storno-kapcsolo">
        <ion-checkbox labelPlacement="end" [(ngModel)]="stornoLatszik">Stornózott jegyek mutatása</ion-checkbox>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card *ngIf="adat?.tanulo">
    <ion-card-header>
      <ion-card-title>{{ adat.tanulo.full_name }}</ion-card-title>
      <ion-card-subtitle>
        {{ adat.tanulo.osztaly || 'Nincs osztály' }} | Oktatási azonosító: {{ adat.tanulo.oktazon }}
      </ion-card-subtitle>
    </ion-card-header>
  </ion-card>

  <!-- BEJELENTETT SZÁMONKÉRÉSEK: az osztálynak és a tanuló csoportjainak szóló, még előttünk
       álló dolgozatok. A több osztályt átfogó csoport tesztje is itt van. -->
  <ion-card *ngIf="kivtanulo && adat?.tanulo">
    <ion-card-header>
      <ion-card-title>Bejelentett számonkérések</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div *ngIf="!kozelgoSzamonkeresek.length">Nincs bejelentett, közelgő számonkérés.</div>
      <ion-list *ngIf="kozelgoSzamonkeresek.length" lines="full">
        <ion-item *ngFor="let s of kozelgoSzamonkeresek">
          <ion-label class="ion-text-wrap">
            <h3><b>{{ s.datum }}</b> · {{ s.tantargy_nev }}<span *ngIf="s.tipus_nev"> · {{ s.tipus_nev }}</span></h3>
            <p>{{ s.cim }}</p>
            <p *ngIf="s.leiras">{{ s.leiras }}</p>
            <p><small>{{ s.csoport_nev || s.osztaly_nev }}<span *ngIf="s.tanar_nev"> · {{ s.tanar_nev }}</span></small></p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="kivtanulo && adat && (!adat.tantargyak || adat.tantargyak.length === 0)">
    <ion-card-content>
      Ehhez a tanulóhoz jelenleg nincs megjeleníthető tantárgy vagy értékelés.
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="adat?.tantargyak?.length">
    <ion-card-header>
      <ion-card-title>Tantárgyi jegyek</ion-card-title>
      <ion-card-subtitle>{{ adat.tanev }}/{{ (+adat.tanev) + 1 }}. tanév</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="scrollable-table">
        <table class="jegyek-table">
          <thead>
            <tr>
              <th>Tantárgy</th>
              <th>09</th>
              <th>10</th>
              <th>11</th>
              <th>12</th>
              <th>01/I</th>
              <th>I</th>
              <th>Átlag</th>
              <th>01/II</th>
              <th>02</th>
              <th>03</th>
              <th>04</th>
              <th>05</th>
              <th>06</th>
              <th>II</th>
              <th>Átlag</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tantargy of adat.tantargyak; let tantargyIndex = index">
              <td>
                <strong>{{ tantargy.tantargy_nev }}</strong>
                <div *ngIf="tantargy.tantargy_rovid">
                  <small>{{ tantargy.tantargy_rovid }}</small>
                </div>
              </td>
              <td *ngFor="let honap of elsoFelevHonapok">
                <ng-container *ngIf="getTantargyMonthMap(tantargy)[honap]?.length; else nincsHonap">
                  <div class="jegy-cell">
                    <span *ngFor="let item of getTantargyMonthMap(tantargy)[honap]; let itemIndex = index" [hidden]="!stornoLatszik && stornoE(item)">
                      <ion-button [attr.data-negyedev]="negyedevJel(item) || null"
                        size="small"
                        fill="clear"
                        [id]="'szuloi-jegy-' + tantargyIndex + '-' + honap + '-' + itemIndex"
                        [style.color]="item.szin || 'inherit'" [class.nem-irta-jegy]="nemIrtaE(item)" [class.storno-jegy]="stornoE(item)"
                        style="--padding-start:0;--padding-end:0;margin:0">
                        <small *ngIf="negyedevesE(item)" class="negyedev-jel">{{ negyedevJel(item) }}</small>{{ jegyRovid(item) }}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container>
                      </ion-button>
                      <ion-popover
                        [trigger]="'szuloi-jegy-' + tantargyIndex + '-' + honap + '-' + itemIndex"
                        triggerAction="click"
                        [showBackdrop]="false">
                        <ng-template>
                          <ion-content class="ion-padding">
                            <b>Téma:</b> {{ item.tema || item.megjegyzese || '-' }}
                            <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – a jegy a pótlás után kerül a helyére.</span>
                            <span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva</b>{{ item.storno_ido ? " (" + formatDatum(item.storno_ido) + ")" : "" }} – a pedagógus visszavonta, az átlagba nem számít.</span>
                            <span *ngIf="isLongErtekeles(item.jegy)">
                              <br><b>Értékelés:</b> {{ item.jegy }}
                            </span>
                            <span *ngIf="getSpecialErtekelesReszletek(item.jegy) as special">
                              <br><b>Magatartás:</b> {{ special.magatartas }}
                              <br><b>Szorgalom:</b> {{ special.szorgalom }}
                            </span>
                            <br><b>Dátum:</b> {{ formatDatum(item.datum) }}
                            <br><b>Tanára:</b> {{ item.tanar_nev || '-' }}
                            <br><b>Súlyozás:</b> {{ item.szorzo ?? '-' }}%
                            <br><b>Típus:</b> {{ item.emnev || item.ertnev || '-' }}
                          </ion-content>
                        </ng-template>
                      </ion-popover>
                    </span>
                  </div>
                </ng-container>
              </td>
              <td class="kiemelt-oszlop">
                <ng-container *ngIf="getTantargyFelevi(tantargy).length; else nincsFelevi">
                  <div class="jegy-cell">
                    <span *ngFor="let item of getTantargyFelevi(tantargy); let itemIndex = index" [hidden]="!stornoLatszik && stornoE(item)">
                      <ion-button [attr.data-negyedev]="negyedevJel(item) || null"
                        size="small"
                        fill="clear"
                        [id]="'szuloi-felevi-' + tantargyIndex + '-' + itemIndex"
                        [style.color]="item.szin || 'inherit'" [class.nem-irta-jegy]="nemIrtaE(item)" [class.storno-jegy]="stornoE(item)"
                        style="--padding-start:0;--padding-end:0;margin:0">
                        <small *ngIf="negyedevesE(item)" class="negyedev-jel">{{ negyedevJel(item) }}</small>{{ jegyRovid(item) }}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container>
                      </ion-button>
                      <ion-popover
                        [trigger]="'szuloi-felevi-' + tantargyIndex + '-' + itemIndex"
                        triggerAction="click"
                        [showBackdrop]="false">
                        <ng-template>
                          <ion-content class="ion-padding">
                            <b>Téma:</b> {{ item.tema || item.megjegyzese || '-' }}
                            <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – a jegy a pótlás után kerül a helyére.</span>
                            <span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva</b>{{ item.storno_ido ? " (" + formatDatum(item.storno_ido) + ")" : "" }} – a pedagógus visszavonta, az átlagba nem számít.</span>
                            <span *ngIf="isLongErtekeles(item.jegy)">
                              <br><b>Értékelés:</b> {{ item.jegy }}
                            </span>
                            <span *ngIf="getSpecialErtekelesReszletek(item.jegy) as special">
                              <br><b>Magatartás:</b> {{ special.magatartas }}
                              <br><b>Szorgalom:</b> {{ special.szorgalom }}
                            </span>
                            <br><b>Dátum:</b> {{ formatDatum(item.datum) }}
                            <br><b>Tanára:</b> {{ item.tanar_nev || '-' }}
                            <br><b>Súlyozás:</b> {{ item.szorzo ?? '-' }}%
                            <br><b>Típus:</b> {{ item.emnev || item.ertnev || '-' }}
                          </ion-content>
                        </ng-template>
                      </ion-popover>
                    </span>
                  </div>
                </ng-container>
                <ng-template #nincsFelevi>-</ng-template>
              </td>
              <td class="atlag-oszlop">{{ getElsoFelevAtlag(tantargy.ertekelesek) }}</td>
              <td *ngFor="let honap of masodikFelevHonapok">
                <ng-container *ngIf="getTantargyMonthMap(tantargy)[honap]?.length; else nincsHonap">
                  <div class="jegy-cell">
                    <span *ngFor="let item of getTantargyMonthMap(tantargy)[honap]; let itemIndex = index" [hidden]="!stornoLatszik && stornoE(item)">
                      <ion-button [attr.data-negyedev]="negyedevJel(item) || null"
                        size="small"
                        fill="clear"
                        [id]="'szuloi-jegy-2-' + tantargyIndex + '-' + honap + '-' + itemIndex"
                        [style.color]="item.szin || 'inherit'" [class.nem-irta-jegy]="nemIrtaE(item)" [class.storno-jegy]="stornoE(item)"
                        style="--padding-start:0;--padding-end:0;margin:0">
                        <small *ngIf="negyedevesE(item)" class="negyedev-jel">{{ negyedevJel(item) }}</small>{{ jegyRovid(item) }}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container>
                      </ion-button>
                      <ion-popover
                        [trigger]="'szuloi-jegy-2-' + tantargyIndex + '-' + honap + '-' + itemIndex"
                        triggerAction="click"
                        [showBackdrop]="false">
                        <ng-template>
                          <ion-content class="ion-padding">
                            <b>Téma:</b> {{ item.tema || item.megjegyzese || '-' }}
                            <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – a jegy a pótlás után kerül a helyére.</span>
                            <span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva</b>{{ item.storno_ido ? " (" + formatDatum(item.storno_ido) + ")" : "" }} – a pedagógus visszavonta, az átlagba nem számít.</span>
                            <span *ngIf="isLongErtekeles(item.jegy)">
                              <br><b>Értékelés:</b> {{ item.jegy }}
                            </span>
                            <span *ngIf="getSpecialErtekelesReszletek(item.jegy) as special">
                              <br><b>Magatartás:</b> {{ special.magatartas }}
                              <br><b>Szorgalom:</b> {{ special.szorgalom }}
                            </span>
                            <br><b>Dátum:</b> {{ formatDatum(item.datum) }}
                            <br><b>Tanára:</b> {{ item.tanar_nev || '-' }}
                            <br><b>Súlyozás:</b> {{ item.szorzo ?? '-' }}%
                            <br><b>Típus:</b> {{ item.emnev || item.ertnev || '-' }}
                          </ion-content>
                        </ng-template>
                      </ion-popover>
                    </span>
                  </div>
                </ng-container>
              </td>
              <td class="kiemelt-oszlop">
                <ng-container *ngIf="getTantargyMasodikFelevi(tantargy).length; else nincsMasodikFelev">
                  <div class="jegy-cell">
                    <span *ngFor="let item of getTantargyMasodikFelevi(tantargy); let itemIndex = index" [hidden]="!stornoLatszik && stornoE(item)">
                      <ion-button [attr.data-negyedev]="negyedevJel(item) || null"
                        size="small"
                        fill="clear"
                        [id]="'szuloi-evvegi-' + tantargyIndex + '-' + itemIndex"
                        [style.color]="item.szin || 'inherit'" [class.nem-irta-jegy]="nemIrtaE(item)" [class.storno-jegy]="stornoE(item)"
                        style="--padding-start:0;--padding-end:0;margin:0">
                        <small *ngIf="negyedevesE(item)" class="negyedev-jel">{{ negyedevJel(item) }}</small>{{ jegyRovid(item) }}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container>
                      </ion-button>
                      <ion-popover
                        [trigger]="'szuloi-evvegi-' + tantargyIndex + '-' + itemIndex"
                        triggerAction="click"
                        [showBackdrop]="false">
                        <ng-template>
                          <ion-content class="ion-padding">
                            <b>Téma:</b> {{ item.tema || item.megjegyzese || '-' }}
                            <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – a jegy a pótlás után kerül a helyére.</span>
                            <span *ngIf="stornoE(item)" class="storno-info"><br><b>Stornózva</b>{{ item.storno_ido ? " (" + formatDatum(item.storno_ido) + ")" : "" }} – a pedagógus visszavonta, az átlagba nem számít.</span>
                            <span *ngIf="isLongErtekeles(item.jegy)">
                              <br><b>Értékelés:</b> {{ item.jegy }}
                            </span>
                            <span *ngIf="getSpecialErtekelesReszletek(item.jegy) as special">
                              <br><b>Magatartás:</b> {{ special.magatartas }}
                              <br><b>Szorgalom:</b> {{ special.szorgalom }}
                            </span>
                            <br><b>Dátum:</b> {{ formatDatum(item.datum) }}
                            <br><b>Tanára:</b> {{ item.tanar_nev || '-' }}
                            <br><b>Súlyozás:</b> {{ item.szorzo ?? '-' }}%
                            <br><b>Típus:</b> {{ item.emnev || item.ertnev || '-' }}
                          </ion-content>
                        </ng-template>
                      </ion-popover>
                    </span>
                  </div>
                </ng-container>
                <ng-template #nincsMasodikFelev>-</ng-template>
              </td>
              <td class="atlag-oszlop">{{ getMasodikFelevAtlag(tantargy.ertekelesek) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ion-card-content>
  </ion-card>

  <ng-template #nincsHonap>-</ng-template>
</ion-content>
